import React, { useRef, useState, useEffect, useMemo } from "react";


import { Alert } from "services/Alert";

import { api } from "api/loginRoutes";
import { ButtonPrimary } from "components/base/BaseButton";

import { Loader, Placeholder, Schema } from "rsuite";
import Form from "components/Form/CompatForm";

const { NumberType } = Schema.Types;

const formModel = Schema.Model({
    call_duration_max: NumberType().min(1, "Enter a positive number").max(10800, "3 hours is maximum").isRequired("Required")
});


const TrafficLimitsSettings = ({
    settings,
    account,
    isSupplier
}) => {
    const formRef = useRef(null);

    const formDefaultValue = useMemo(() => {
        return {
            call_duration_max: settings?.call_duration_max
        };
    }, [settings?.call_duration_max]);

    const [formValue, setFormValue] = useState(formDefaultValue);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormValue(formDefaultValue);
    }, [formDefaultValue]);

    if (!isSupplier && !settings?.call_duration_max) {
        return <>
            <div style={{ height: 106, position: "relative" }}>
                <Loader backdrop content="loading..." vertical />
                <Placeholder.Paragraph />
            </div>
        </>;
    }

    const handleApply = async () => {
        if (!formRef.current.check())
            return;

        setLoading(true);

        const newData = {
            call_duration_max: parseInt(formValue.call_duration_max || settings.call_duration_max)
        };

        api("account:modify", {
            ...newData,
            cur_key: undefined,
            target: {
                account_id: account.id
            }
        },
            true).then((result) => {
                if (result.account) {
                    setLoading(false);
                    Alert.success("Saved");
                } else {
                    Alert.error("Something wrong");
                }
            }).finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {!isSupplier && <Form
                layout="inline"
                model={formModel}
                className="mailingSettings"
                ref={formRef}
                formDefaultValue={formDefaultValue}
                formValue={formValue}
                onChange={setFormValue}
            >
                <Form.Group>
                    <Form.ControlLabel> Call Duration </Form.ControlLabel>
                    <Form.Control
                        name="call_duration_max"
                        placeholder="2400"
                        style={{ width: "180px" }}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonPrimary
                        style={{ padding: "8px 34px", marginLeft: 12 }}
                        onClick={handleApply}
                        loading={loading}
                    >
                        Save
                    </ButtonPrimary>
                </Form.Group>
            </Form>}
        </>
    );
};

export default TrafficLimitsSettings;
